import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para formatear fechas personalizado
 * Uso: {{ date | dateCustom:'dd/MM/yyyy' }}
 */
@Pipe({
  name: 'dateCustom',
  standalone: true
})
export class DateCustomPipe implements PipeTransform {
  transform(value: Date | string | number, format: string = 'dd/MM/yyyy'): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    
    if (isNaN(date.getTime())) {
      return '-';
    }

    const day = this.pad(date.getDate());
    const month = this.pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = this.pad(date.getHours());
    const minutes = this.pad(date.getMinutes());
    const seconds = this.pad(date.getSeconds());

    return format
      .replace('dd', day)
      .replace('MM', month)
      .replace('yyyy', year.toString())
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);
  }

  private pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}

